import {Component, Input} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UserGenericComponent } from '../../../user-generic.component';
import { FormsService } from '../../../../shared/forms.service';
import { UserService } from '../../../shared/user.service';
import { UserFormService } from '../../../shared/user-form.service';
import { SchoolRequest } from '@builtbybros/al-model';

@Component({
  selector: 'app-school-form',
  templateUrl: './school-form.component.html',
  styleUrls: ['./school-form.component.scss', '../../../shared/invalid-form.scss'],
  providers: [UserFormService]
})
export class SchoolFormComponent extends UserGenericComponent {

  schoolForm: FormGroup;
  @Input() userRole;
  msg = {
    'instituteNameRequired': 'Debe especificar el nombre de la institución',
    'instituteNameLength': 'Nombre de la institución muy largo',
  };


  constructor(private fb: FormBuilder,
              private formsService: FormsService,
              private userService: UserService
  ) {
    super(formsService);
    this.createFormGroup();
  }


  public createFormGroup() {
    this.schoolForm = this.fb.group({
      'instituteName': [
        null,
        Validators.compose([
          Validators.required,
          Validators.maxLength(50)
        ])
      ],
    });
  }

  public getFormGroup(): FormGroup {
    return this.schoolForm;
  }

  compareUserRole(role: number): boolean {
    return (role === 4);
  }


  getForm(): FormGroup {
    return this.schoolForm;
  }

  submitForm(userInfo: any, id?: number) {
    let upsert;
    if (id) {
      const school = new SchoolRequest.Update();
      school.parse(this.schoolForm.value);
      school.parse(userInfo);
      school.id = id;
      upsert = this.userService.updateSchool(id, school);
    } else {
      let school = new SchoolRequest.Create();
      school.parse(this.schoolForm.value);
      school.parse(userInfo);
      upsert = this.userService.createSchool(school);
    }
    return upsert;
  }
}



// WEBPACK FOOTER //
// ./src/app/user/school/shared/school-form/school-form.component.ts